import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/brand/Logo";

/**
 * Two-column matte-black auth shell used by Login, Register and AuthCallback.
 * Left: brand + tagline. Right: form.
 */
export default function AuthShell({ children, side = "left" }) {
  return (
    <div className="min-h-screen grid md:grid-cols-2 bg-matte text-white">
      {side === "left" && (
        <aside className="relative hidden md:flex flex-col justify-between p-12 border-r border-white/10 overflow-hidden">
          <Link to="/">
            <Logo variant="inline" size={40} />
          </Link>
          <div className="relative z-10">
            <div className="font-display uppercase text-[11px] tracking-[0.4em] text-gold mb-4">
              The Song Comes First
            </div>
            <h2 className="font-display uppercase text-4xl lg:text-5xl leading-none tracking-tight">
              A compass for the <span className="text-gold-sheen">craft</span>.
            </h2>
            <p className="mt-6 text-white/60 max-w-md leading-relaxed">
              Ownership stays with the writer. Discovery runs on merit. A
              professional ecosystem built for the song and the industry that
              lifts it.
            </p>
          </div>
          <div className="relative z-10 text-[10px] uppercase tracking-[0.35em] text-white/40 font-display">
            © {new Date().getFullYear()} Songwriter Square
          </div>
          <div className="absolute -bottom-24 -left-24 h-96 w-96 rounded-full bg-gold/10 blur-3xl pointer-events-none" />
          <div className="absolute top-1/3 -right-24 h-72 w-72 rounded-full bg-gold/5 blur-3xl pointer-events-none" />
        </aside>
      )}
      <main className="flex flex-col justify-center p-8 md:p-12">
        <Link to="/" className="md:hidden mb-8 inline-flex">
          <Logo variant="inline" size={34} />
        </Link>
        {children}
      </main>
    </div>
  );
}
